module.exports = __webpack_public_path__ + "img/5.26fbf2ea.png";